'use strict';

angular.module('theme').component('carouselSpecific', {
	templateUrl: 'component/carousel-specific.html',
	bindings: {
		productId: '@',
		productImage: '@',
		productTitle: '@',
	},
	controller: function ($scope, $window, $location, $cookies, CartService, ArticleService, ProductService, TrackerService, ProductTrackerService) {
		var self = this;


		self.special = self.productId === 'Special';

		ArticleService.getProduct(self.productId).then(function (product) {
			self.product = product;
			self.prices = product.prices;

			self.selected = _.find(self.prices, function(price) {
				if (self.special) return price.number === 1;
				return price.number === 4;
			});

			ProductTrackerService.updateProduct(self.product, self.selected, self.getServings());
		});

		this.select = function () {
			CartService.add(self.product, this.selected.number).then(function () {

				// get wordpress product
				ProductService.get(self.product.type).then(function (product) {
					var data = {
						'currency': 'SEK',
						'add': {
							'actionField': {'list': window.location.pathname},
							'products': [{
								'name': product.title,
								'id': self.product.type,
								'price': self.selected.amount,
								'quantity': 1,
								'dimension3': self.getServings(),
								'dimension4': self.selected.number
							}]
						}
					};

					//TrackerService.ecommerceEvent('addToCart', data);
				});

				TrackerService.addToCart(self.product, self.selected.amount);

				// redirect to cart
				$window.location.href = '/order/';
			});
		};



		this.getServings = function () {
			switch(self.productId) {
			case 'VEGO':
			case 'STHLM':
				return 3;
			default:
				return 4;
			}
		};
	}
});
